var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#CFD2FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2148 15.7454C22.2147 16.0108 22.1089 16.2653 21.9209 16.4528L18.441 19.9228C18.0499 20.3127 17.4167 20.3118 17.0267 19.9208C16.6368 19.5297 16.6377 18.8965 17.0288 18.5065L19.7996 15.7436L17.0278 12.9718C16.6372 12.5812 16.6372 11.9481 17.0278 11.5575C17.4183 11.167 18.0515 11.167 18.442 11.5575L21.922 15.0376C22.1097 15.2253 22.215 15.4799 22.2148 15.7454Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2148 15.7454C16.2147 16.0108 16.1089 16.2653 15.9209 16.4528L12.441 19.9228C12.0499 20.3127 11.4167 20.3118 11.0267 19.9208C10.6368 19.5297 10.6377 18.8965 11.0288 18.5065L13.7996 15.7436L11.0278 12.9718C10.6372 12.5812 10.6372 11.9481 11.0278 11.5575C11.4183 11.167 12.0515 11.167 12.442 11.5575L15.922 15.0376C16.1097 15.2253 16.215 15.4799 16.2148 15.7454Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.2feb7f4f4f657787eddd018751e28331.svg";
export { ForwardRef as ReactComponent };